import { Component, OnInit, ViewChild } from "@angular/core";
import { ReportingPagesDataService } from "../reporting-pages-data.service";
import { Dictionary } from "src/app/store/models/common_types";
import { ActivatedRoute, Router } from "@angular/router";
import { ReportingGridWrapperComponent } from "../reporting-grid-wrapper/reporting-grid-wrapper.component";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import * as GlobalSubheaderActions from "../../store/actions/global-subheader.actions";
import { Subscription } from "rxjs";
import { ReportingPagesService } from "../reporting-pages.service";
import { NzMessageService } from "ng-zorro-antd/message";
@Component({
  selector: "app-reporting-analyst",
  templateUrl: "./reporting-analyst.component.html",
  styleUrls: ["./reporting-analyst.component.scss"],
  host: { class: "analyst-page-component" },
})
export class ReportingAnalystComponent implements OnInit {
  showSearch = true;
  analystId: string;
  analystName: string;
  showGridFilters: boolean;
  coveragestatusList: Array<any> = [];
  legacyDomain: string = window.caUrl;
  page: string;
  columns: {
    columnFields: Array<Dictionary<any>>;
    columnsData: Array<Dictionary<any>>;
    widthConfig: Array<string>;
    setWidth: boolean;
  };
  gridUrl: string;
  sortKey: string;
  exportKey: string;
  exportColumns: Array<any>;
  sourceName: string;
  sourceSn: string;
  globalSearchVal: string;
  @ViewChild(ReportingGridWrapperComponent)
  gridWrapperComp: ReportingGridWrapperComponent;
  columnList: Array<any>;
  columnFields: Array<any>;
  columnsData: Array<any>;
  widthConfig: Array<any>;
  storeSub: Subscription;
  isDataSet: boolean;
  isSellside: boolean;
  constructor(
    private dataService: ReportingPagesDataService,
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private service: ReportingPagesService,
    private message: NzMessageService,
    private router: Router,
  ) {
    this.columns = {
      columnFields: [],
      columnsData: [],
      widthConfig: [],
      setWidth: true,
    };
    this.isDataSet = false;
    this.coveragestatusList = this.dataService.getCoverageStatusValue();
    this.storeSub = this.store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data: any) => {
        if (Object.keys(data).length === 0 && data.constructor === Object) {
          return;
        }
        this.isSellside = data.isSellside;
        if (this.isSellside) {
          this.columnList.push("views");
        } else if (this.columnList.includes("views")) {
          this.columnList.pop();
        }
        this.columnDataChange();
      });
  }

  ngOnInit() {
    this.route.params.subscribe(() => {
      const urlArr = window.location.pathname.split("/");
      this.analystId = urlArr[urlArr.length - 1];
      this.analystId = urlArr[urlArr.length - 1];
      this.isDataSet = false;
      this.dataService.getAnalystMetaInfo(this.analystId).subscribe((res) => {
        if (res.status === "error") {
          //error encountered redirect to home page
          this.message.error(res.message, {
            nzDuration: 2000,
          });
          setTimeout(() => {
            this.router.navigateByUrl("/home");
          }, 2000);
          throw new Error(res.message);
        }
        this.analystName = res.analyst_fn_ln;
        this.sourceName = res.source_name;
        this.sourceSn = res.source_sn;
        if (!this.isSellside) {
          res.columns = res.columns.filter((val) => val !== "views");
        }
        this.columnList = res.columns.map((val) => {
          let field = val;
          switch (val) {
            case "sector":
              field = "sectorname";
              break;
            case "industry":
              field = "industryname";
              break;
            case "size":
              field = "filesize";
              break;
            case "In VA Consensus?":
              field = "inconsensus";
              break;
            case "Coverage Status":
              field = "coveragestatus";
              break;
            default:
              break;
          }
          return field;
        });
        this.columnDataChange();
      });

      this.page = "analyst";
      this.gridUrl = `api/brokeranalystdata?analystid=${this.analystId}&`;
      this.service.logUserOnRedirection("ANALYST_PAGE", {
        VALUE: this.analystId,
      });
      this.store.dispatch(new GlobalSubheaderActions.SubheaderChanged());
    });
    this.columnFields = [
      {
        field: "ticker",
        renderer: "link",
      },
      {
        field: "companyname",
        renderer: "link",
      },
      {
        field: "country",
        renderer: null,
      },
      {
        field: "sectorname",
        renderer: "link",
      },
      {
        field: "industryname",
        renderer: "link",
      },
      {
        field: "peers",
        renderer: null,
      },
      {
        field: "modeldate",
        renderer: null,
      },
      {
        field: "filesize",
        renderer: "report-model-link",
      },
      {
        field: "inconsensus",
        renderer: null,
      },
      {
        field: "coveragestatus",
        renderer: null,
      },
      {
        field: "views",
        renderer: "report-view-link",
      },
    ];
    this.columnsData = [
      {
        children: 1,
        header: "Ticker",
        sortKey: "ticker",
        showSort: true,
        showFilter: true,
        filterType: "text",
      },
      {
        children: 1,
        header: "Company",
        sortKey: "companyname",
        showSort: true,
        showFilter: true,
        filterType: "text",
      },
      {
        children: 1,
        header: "Country",
        sortKey: "country",
        showSort: true,
        showFilter: true,
        filterType: "text",
      },
      {
        children: 1,
        header: "Sector",
        sortKey: "sectorname",
        showSort: true,
        showFilter: true,
        filterType: "text",
      },
      {
        children: 1,
        header: "Industry",
        sortKey: "industryname",
        showSort: true,
        showFilter: true,
        filterType: "text",
      },
      {
        children: 1,
        header: "Peers",
        sortKey: "peers",
        showSort: true,
        showFilter: true,
        filterType: "text",
      },
      {
        children: 1,
        header: "Model Date",
        sortKey: "modeldate",
        showSort: true,
        showFilter: false,
      },
      {
        children: 1,
        header: "Model",
        sortKey: "filesize",
        showSort: false,
        showFilter: false,
      },
      {
        children: 1,
        header: "In VA Consensus?",
        sortKey: "inconsensus",
        showSort: false,
        showFilter: true,
        filterType: "select",
        filterSelectValues: [
          { val: "", display: "[All]" },
          { val: "yes", display: "Yes" },
          { val: "no", display: "No" },
          { val: "not current", display: "Not Current" },
        ],
        currentValue: "",
      },
      {
        children: 1,
        header: "Coverage Status",
        sortKey: "coveragestatus",
        showSort: false,
        showFilter: true,
        filterType: "select",
        filterSelectValues: this.coveragestatusList,
        currentValue: "",
      },
      {
        children: 1,
        header: "Views",
        sortKey: "views",
        showSort: false,
        showFilter: false,
      },
    ];
    this.widthConfig = [
      "120px", //ticker
      "220px", //companyname
      "120px", //country
      "170px", //sectorname
      "180px", //industryname
      "120px", //peers
      "120px", //modeldate
      "100px", //filesize
      "120px", //inconsensus
      "150px", //Contenttype
      "280px", //views
    ];
  }

  toggleFilter(ev) {
    this.showGridFilters = ev.showFilters;
  }

  onSearch(val) {
    this.globalSearchVal = val;
  }

  onReloadGrid() {
    this.gridWrapperComp.gridReload();
  }
  columnDataChange() {
    let columnFields = [];
    const columnData = [],
      colWidths = [];
    for (let index = 0; index < this.columnList.length; index++) {
      const element = this.columnList[index];
      columnFields.push(
        this.columnFields.filter((val, i) => {
          if (val.field === element) {
            columnData.push(this.columnsData[i]);
            colWidths.push(this.widthConfig[i]);
            return val;
          }
          return null;
        })[0],
      );
    }
    columnFields = columnFields.filter(
      (val) => val !== null && val !== undefined,
    );
    this.sortKey = "companyname";
    this.exportKey = `ANALYST_PAGE_${this.analystId}`;
    this.columns = {
      columnFields: columnFields,
      columnsData: [columnData],
      widthConfig: colWidths,
      setWidth: true,
    };
    this.exportColumns = columnData.map((d) => {
      return d.sortKey;
    });
    this.isDataSet = this.isSellside !== undefined;
  }
  ngOnDestroy() {
    this.storeSub.unsubscribe();
  }
}
